import { render } from "./ConfigureWebhooks.vue?vue&type=template&id=76d06fe8"
import script from "./ConfigureWebhooks.vue?vue&type=script&lang=js"
export * from "./ConfigureWebhooks.vue?vue&type=script&lang=js"

import "./ConfigureWebhooks.vue?vue&type=style&index=0&id=76d06fe8&lang=scss"
script.render = render

export default script